import React, {useState} from "react"

import "./Sign.css"

import Nav from "../../component/Nav/Nav"
import Footer from "../../component/Footer/Footer"
import SubBanner from "../../component/SubBanner/SubBanner"
import {sendRequest, validateEmail} from "../../common";

function ResetPW() {

	const [email, setEmail] = useState('')

	let isLoading = false

	const sendResetPassword = () => {
		if (isLoading) return
		isLoading = true

		sendRequest('accounts/password-reset/', 'POST', {
			email
		}, data => {
			alert(data?.msg)
			isLoading = false
		}, data => {
			alert(data?.msg)
			isLoading = false
		})
	}

	return (
		<>
			<Nav />
			<SubBanner title={"비밀번호 재설정"} firstText={"인컬리지에서 다양한 서비스를 경험해보세요."} />
			<div className="container">
				<div className="cardContent signCard">
					<section>
						<form className="cardForm" name="signUp">
							<div className="memberWrap">
								<button className="active" type="button">
									전문가 회원
								</button>
								<button type="button">일반 회원</button>
							</div>
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">이메일</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="email" name="emailId" placeholder="이메일을 입력해주세요" required onChange={e => setEmail(e.target.value)} onBlur={() => validateEmail(email, setEmail)}/>
										</span>
									</div>
									<span className="formInfo">
										회원가입 시 등록한 이메일을 정확히 입력해주세요.
									</span>
								</div>
							</div>
								<button className="submitBtn" type="submit" onClick={e => {
									e.preventDefault()
									sendResetPassword()
								}}>
									비밀번호 재설정 메일 발송
								</button>
						</form>
					</section>
				</div>
			</div>

			<Footer />
		</>
	)
}

export default ResetPW
